<template>
  <div
    class="min-h-screen flex flex-col justify-between p-3 pb-6 bg-blue-DEFAULT sm:sticky sm:top-0 sm:h-screen scroll"
    v-on:scroll.stop
  >
    <div class="mb-5 flex justify-between">
      <button
        class="bg-gray-dark text-gray-light text-base py-1 px-2 border-2 border-transparent focus:outline-none hover:bg-gray-darker"
        @click="handleClickOpenSidebar"
      >
        Search for place
      </button>
      <button
        class="h-10 w-10 bg-gray-dark rounded-full border-2 border-transparent focus:outline-none hover:bg-gray-darker"
        @click="handleGetCurrentGeolocation"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 m-auto text-gray-light" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 7H7v6h6V7z" />
          <path fill-rule="evenodd" d="M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
    <div class="w-full h-48 mb-8 relative">
      <img class="h-full m-auto bg-opacity-clouds"  src="./../assets/images/Cloud-background.png" alt="clouds">
      <img class="h-1/2 absolute inset-0 m-auto" :src="require(`@/assets/images/${weatherForecast.currentDay.state}.png`)" :alt="weatherForecast.state">
    </div>
    <div class="mb-12 w-full flex justify-center items-baseline">
      <span class="text-gray-light text-8xl font-medium">{{weatherForecast.currentDay.temperature}}</span>
      <span class="text-gray-DEFAULT text-4xl">°{{unitTemperature}}</span>
    </div>
    <p class="mb-8 text-2xl font-semibold text-center text-gray-DEFAULT">
      {{weatherForecast.state}}
    </p>
    <p class="mb-6 text-gray-DEFAULT text-center">
      <span>Today</span>
      <span class="mx-3">-</span>
      <span>{{weatherForecast.currentDay.date}}</span>
    </p>
    <p class="flex justify-center text-lg text-gray-DEFAULT">
      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 h-5 w-5 text-gray-DEFAULT" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
      </svg>
      {{weatherForecast.currentDay.location}}
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "CurrentWeather",
  computed: {
    ...mapState(["unitTemperature", "weatherForecast"])
  },
  methods: {
    handleClickOpenSidebar () {
      this.$store.dispatch("openSidebar");
    },
    async handleGetCurrentGeolocation () {
      try {
        const { coords: { latitude, longitude } } = await this.$store.dispatch("getCurrentLatitudeLongitude");

        await this.$store.dispatch("getGeoLocationIDByLattLong", { latitude, longitude });
      } catch (e) {
        let errorMessage;

        if (e instanceof window.GeolocationPositionError && e.code != 1) {
          errorMessage = "We've had trouble getting your Geolocation";
        } else {
          errorMessage = e.message;
        }

        this.$toast.error(errorMessage);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.bg-opacity-clouds {
  opacity: .1;
}
</style>
